import { v4 as uuidv4 } from "uuid";
import { Headers } from "../enums/Headers";
// Helper function to validate email format
export var isValidEmail = function (email) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
};
export var getCookie = function (cookieName) {
    var cookies = document.cookie.split(";");
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var _a = cookie.trim().split("="), name_1 = _a[0], value = _a[1];
        if (name_1 === cookieName) {
            return decodeURIComponent(value);
        }
    }
    return null;
};
export var isAuthenticated = function () {
    var authStatus = getCookie("isAuthenticated");
    return authStatus === "true";
};
export var generateUniqueId = function () {
    return uuidv4();
};
export var generatePrefixedId = function (prefix) {
    return "".concat(prefix, "_").concat(crypto.randomUUID().replace(/-/g, ""));
};
export var addCustomHeaders = function (headers) {
    headers[Headers.REQUEST_ID_HEADER] = generatePrefixedId("req");
    var correlationId = sessionStorage.getItem(Headers.CORRELATION_ID_STORAGE_KEY);
    if (!correlationId) {
        correlationId = generatePrefixedId("corr");
        sessionStorage.setItem(Headers.CORRELATION_ID_STORAGE_KEY, correlationId);
    }
    headers[Headers.CORRELATION_ID_HEADER] = correlationId;
    return headers;
};
export var addBypassHeaders = function (headers) {
    var BYPASS_ENV_ID = process.env.REACT_BYPASS_ENV_ID;
    var dummy_user_id = process.env.REACT_DUMMY_USER_ID;
    if (BYPASS_ENV_ID) {
        headers["current_env"] = BYPASS_ENV_ID;
        dummy_user_id && (headers["dummy_user_id"] = dummy_user_id);
    }
    return headers;
};
export var getImageUrl = function (fileName) {
    return "".concat(process.env.REACT_APP_IMAGE_BASE_URL, "/").concat(fileName);
};
export var dateToLocalString = function (date) {
    return date.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
    });
};
export var getTripDuration = function (startDate, endDate) {
    // Parse input strings "DD-MM-YYYY"
    var _a = startDate.split("-").map(Number), sDay = _a[0], sMonth = _a[1], sYear = _a[2];
    var _b = endDate.split("-").map(Number), eDay = _b[0], eMonth = _b[1], eYear = _b[2];
    var start = new Date(sYear, sMonth - 1, sDay);
    var end = new Date(eYear, eMonth - 1, eDay);
    // 1. Calculate Duration (Inclusive)
    var diffInMs = end.getTime() - start.getTime();
    var diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24)) + 1;
    // 2. Format the Display (e.g., "Oct 26 - 30" or "Oct 26 - Nov 2")
    var startMonth = start.toLocaleString("default", { month: "short" });
    var endMonth = end.toLocaleString("default", { month: "short" });
    var startDayNum = start.getDate();
    var endDayNum = end.getDate();
    var dateRangeDisplay = "";
    if (startMonth === endMonth && sYear === eYear) {
        // Same month: "Oct 26 - 30"
        dateRangeDisplay = "".concat(startMonth, " ").concat(startDayNum, " - ").concat(endDayNum);
    }
    else if (sYear === eYear) {
        // Different month, same year: "Oct 26 - Nov 2"
        dateRangeDisplay = "".concat(startMonth, " ").concat(startDayNum, " - ").concat(endMonth, " ").concat(endDayNum);
    }
    else {
        // Different years: "Dec 28, 2025 - Jan 2, 2026"
        dateRangeDisplay = "".concat(startMonth, " ").concat(startDayNum, ", ").concat(sYear, " - ").concat(endMonth, " ").concat(endDayNum, ", ").concat(eYear);
    }
    return {
        startDate: start.toLocaleDateString("en-IN"), // or use your dateToLocalString
        endDate: end.toLocaleDateString("en-IN"),
        duration: diffInDays,
        dateRangeDisplay: dateRangeDisplay,
    };
};
